import { useContext } from "react";
import { InvoiceModalContext } from "./InvoiceModalProvider";

export const useInvoiceModal = () => useContext(InvoiceModalContext);
